export default "__VITE_PUBLIC_ASSET__6fef7e3f__"